import axios from "axios";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_NEXTGEN_API || 'http://api.shortlister.local';
const PREFIX = process.env.REACT_APP_NEXTGEN_PREFIX;
const COOKIE_ID = process.env.REACT_APP_COOKIE_ID;

const nextgenApiClient = axios.create();

nextgenApiClient.interceptors.request.use(
    (config) => {
        config.headers['Cookie-ID'] = Cookies.get(COOKIE_ID);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getHasProjectAccess = async () => {
    try {
        const {data} = await nextgenApiClient.get(`${API_BASE_URL}${PREFIX}/broker/v1/project/has-access`);
        return data.has_access;
    } catch (error) {
        return false;
    }
};
